import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ConnectionService } from '../../service/connection.service';
import { TranslatePipe } from '@ngx-translate/core';
import { CapsLockWarningDirective } from '../../utility/caps-lock-warning.directive';
import { AuthService } from '../../service/auth.service';
import { GoogleSigninButtonComponent } from '../../google-signin-button/google-signin-button.component';
import { environment } from '../../../environments/environment';
import { IconComponent } from '../../components/icon/icon.component';

@Component({
  selector: 'app-login',
  imports: [CommonModule, FormsModule, TranslatePipe, RouterLink, CapsLockWarningDirective, GoogleSigninButtonComponent, IconComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  username = '';
  password = '';
  remember = false;
  errorMsg = '';
  emailNotVerified = false;
  googleClientId = environment.googleClientId;
  showPassword = false;
  private returnUrl: string | null = null;

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private connection: ConnectionService,
    private authService: AuthService,
  ) {
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
  }

  onSubmit() {
    this.errorMsg = '';
    this.emailNotVerified = false;
    this.connection.post(
      '@auth/login',
      { username: this.username, password: this.password, remember: this.remember },
      this.login_success.bind(this),
      this.login_error.bind(this),
    );
  }

  login_success(result: any) {
    const route = this.authService.applyLoginResult(result, this.returnUrl);
    this.router.navigate([route]);
  }

  login_error(error: any) {
    this.errorMsg = error?.error?.message || 'Credenziali non valide';
    this.emailNotVerified = error?.error?.code === 'EMAIL_NOT_VERIFIED';
    this.password = '';
  }

  register() {
    this.router.navigate(['/registrazione']);
  }

  onGoogleSuccess(result: any) {
    this.login_success(result);
  }

  onGoogleFailure(error: any) {
    this.errorMsg = error?.error?.message || 'Accesso con Google non riuscito';
  }
}
